import keyboard from '../utils/keyboard';
import $ from '../utils/jquery';
const $dropdowns = $( '[data-navdropdown="component"]' );
const state = {
	visible: 'submenu-visible',
	hidden: 'submenu-hidden'
};

const getSubmenu = $dropdown => {
	return $dropdown.find( '[data-navdropdown="submenu"]' );
};

const getToggle = $dropdown => {
	return $dropdown.find( '[data-navdropdown="toggle"]' );
};

const getSubmenuLinks = $dropdown => {
	return $dropdown.find( '[data-navdropdown="submenu"] a' );
};

const getOpenedDropdown = () => {
	return $( `[data-navdropdown="component"].${ state.visible }` );
};

const hideOnEscape = e => {
	const $openedDropdown = getOpenedDropdown();
	const isEscape = e.keyCode === keyboard.escape ? true : false;

	if ( isEscape && $openedDropdown.length ) {
		hideDropdown( $openedDropdown );
	}
};

const hideOnClick = e => {
	const $openedDropdown = getOpenedDropdown();
	const $toggle = getToggle( $openedDropdown );

	// Only hide if not clicking on toggle
	if ( $( e.target )[ 0 ] === $toggle[ 0 ] ) {
		return;
	}

	hideDropdown( $openedDropdown );
};

const handleToggleClick = $dropdown => {
	const $toggle = getToggle( $dropdown );

	// Ignore if link
	if ( $toggle.prop( 'tagName' ).toLowerCase() === 'a' ) {
		return;
	}

	// Toggle if button
	if ( $dropdown.hasClass( state.hidden ) ) {
		showDropdown( $dropdown );
		return;
	}

	hideDropdown( $dropdown );
};

const showDropdown = $dropdown => {
	// Dont re-bind if focusing back
	if ( $dropdown.hasClass( state.visible ) ) {
		return;
	}

	const $toggle = getToggle( $dropdown );
	const $submenuLinks = getSubmenuLinks( $dropdown );

	positionSubmenu( $dropdown );

	// Show submenu
	$dropdown
		.removeClass( state.hidden )
		.addClass( state.visible );

	// Hide submenu if no longer hovering on submenu
	$dropdown.on( 'mouseout', e => {
		if ( stillOnDropdown( $( e.relatedTarget ) ) ) {
			return;
		}

		hideDropdown( $dropdown );
	} );

	// Keyboard functionality for toggle
	$toggle.on( 'keydown', e => {
		// Hide submenu if toggle tabbed to previous link
		if ( ( e.keyCode === keyboard.tab && e.shiftKey ) ) {
			hideDropdown( $dropdown );
		}

		// Focus on first submenu link if down arrow pressed
		if ( ( e.keyCode === keyboard.down ) ) {
			e.preventDefault();
			$submenuLinks.first().focus();
		}
	} );

	// Keyboard arrow key navigation for submenu links
	$submenuLinks.on( 'keydown', e => {
		// Down Arrow
		if ( ( e.keyCode === keyboard.down ) ) {
			e.preventDefault();

			$( e.currentTarget )
				.parent()
				.next()
				.find( 'a' )
				.focus();
		}

		// Up Arrow
		if ( ( e.keyCode === keyboard.up ) ) {
			e.preventDefault();

			$( e.currentTarget )
				.parent()
				.prev()
				.find( 'a' )
				.focus();
		}
	} );

	// Focus to toggle if up arrow pressed on first submenu link
	$submenuLinks.first().on( 'keydown', e => {
		if ( ( e.keyCode === keyboard.up ) ) {
			e.preventDefault();
			$toggle.focus();
		}
	} );

	// Hide submenu on focus out on last link
	$submenuLinks.last().on( 'keydown', e => {
		if ( ( e.keyCode === keyboard.tab && ! e.shiftKey ) ) {
			hideDropdown( $dropdown );
		}
	} );

	// Hide submenu on escape
	$( document ).on( 'keydown', hideOnEscape );

	// Hide submenu on click
	$( document ).on( 'click', hideOnClick );
};

const positionSubmenu = $dropdown => {
	const $submenu = getSubmenu( $dropdown );
	const gutter = 15;
	const windowWidth = window.innerWidth;
	const dropdownWidth = $dropdown.outerWidth();
	const dropdownLeftPos = $dropdown.get( 0 ).offsetLeft;
	const dropdownCenterPos = ( dropdownWidth / 2 ) + dropdownLeftPos;
	const submenuWidth = $submenu.outerWidth();

	$submenu.removeClass( 'position-right position-left position-center' );

	if ( dropdownCenterPos + ( submenuWidth / 2 ) > windowWidth - gutter ) {
		$submenu.addClass( 'position-right' );
		return;
	}

	if ( dropdownCenterPos - ( submenuWidth / 2 ) < gutter ) {
		$submenu.addClass( 'position-left' );
		return;
	}

	$submenu.addClass( 'position-center' );
};

const stillOnDropdown = $el => {
	if ( $el.hasClass( state.visible ) ) {
		return true;
	}

	if ( $el.parents( `.${ state.visible }` ).length ) {
		return true;
	}

	return false;
};

const hideDropdown = $dropdown => {
	const $toggle = getToggle( $dropdown );
	const $submenuLinks = getSubmenuLinks( $dropdown );

	$dropdown
		.removeClass( state.visible )
		.addClass( state.hidden );

	// Unbind all events
	$dropdown.off( 'mouseout' );
	$toggle.off( 'keydown' );
	$submenuLinks.off( 'keydown' );
	$( document ).off( 'keydown', hideOnEscape );
	$( document ).off( 'click', hideOnClick );
};

const bind = () => {
	$dropdowns.each( ( i, el ) => {
		const $dropdown = $( el );
		const $toggle = getToggle( $dropdown );
		const $submenuLinks = getSubmenuLinks( $dropdown );

		$toggle.on( 'mouseenter focus', () => {
			showDropdown( $dropdown );
		} );

		$toggle.on( 'click', () => {
			handleToggleClick( $dropdown );
		} );

		// Open dropdown if focus on a submenu link
		$submenuLinks.on( 'focus', () => {
			if ( $dropdown.hasClass( state.hidden ) ) {
				showDropdown( $dropdown );
			}
		} );
	} );
};

export default () => {
	if ( ! $dropdowns.length ) {
		return;
	}

	bind();
};
